import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { UserService } from "@core/services/user.service";

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleGuard implements CanActivate {

  constructor(private router: Router,
              private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const path = route.routeConfig.path;
    return true;
  }
}
